import {
  Action,
  ActionType,
  IFirstSectionResponse,
} from "models/dashboard/firstSection";
import createReducer from "../../createReducer";

export interface FirstSectionReducerType {
  loading: boolean;
  error?: string;
  firstSectionResponse?: IFirstSectionResponse;
}

const defaultState: FirstSectionReducerType = {
  loading: false,
  error: undefined,
  firstSectionResponse: undefined,
};

export const getFirstSectionReducer = createReducer<FirstSectionReducerType>(
  defaultState,
  {
    [ActionType.GET_FIRST_SECTION_DATA](state: FirstSectionReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.GET_FIRST_SECTION_DATA_ERROR](
      state: FirstSectionReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.GET_FIRST_SECTION_DATA_SUCCESS](
      state: FirstSectionReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        firstSectionResponse: action.payload,
      };
    },
  }
);
